import dayjs from "dayjs"
import { getValidDayjs } from "../safeParse/getValidDayjs"
import timezone from 'dayjs/plugin/timezone'
import { formatOnlyAllowNumber } from "../app/formatOnlyAllowNumber"

dayjs.extend(timezone)

export const getDatetimeSegment = (date: any, tz?: string) => {
  let startTime = getValidDayjs(date).utc()
  if (tz) {
    const offset = formatOnlyAllowNumber(tz.split(':')[0])
    startTime = startTime.utcOffset(offset)
  }
  return startTime
}